import { Layout } from 'antd';
import clsx from 'clsx';
import moment from 'moment';
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { useMedia } from 'react-use';
import { AppContext } from '../AppContext';
import { BREAKPOINTS, SUBSCRIPTION_STATUS } from '../common/constants';
import VerifyDetailsModal from '../modules/auth/VerifyDetailsModal';
import './App.css';
import AppHeader from './components/header/AppHeader';
import MobileHeader from './components/header/MobileHeader';
import GracePeriodMessage from './components/subscriptionPopups/GracePeriodMessage';
import OneMonthExpiryMessage from './components/subscriptionPopups/OneMonthExpiryMessage';
import VerificationPendingBar from './components/subscriptionPopups/VerificationPendingBar';

const VERSION = require('../../package.json').version;

const { Content, Footer } = Layout;

const App = () => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const { getCurrentUser, state } = useContext(AppContext);
  const tenantUser = getCurrentUser()?.tenantUser;
  const currentUser = getCurrentUser();
  return (
    <>
      <Layout className="gx-app-layout">
        {(!currentUser?.emailVerified ||
          (!currentUser?.numberVerified && currentUser?.phoneNo)) && (
          <VerificationPendingBar />
        )}
        {tenantUser?.tenant?.subscription?.status ===
        SUBSCRIPTION_STATUS.OVER_DUE ? (
          <GracePeriodMessage />
        ) : (
          tenantUser?.tenant?.subscription?.status ===
            SUBSCRIPTION_STATUS.ACTIVE &&
          moment().isSameOrAfter(
            moment(tenantUser?.tenant?.subscription?.validTill).subtract(
              1,
              'month',
            ),
          ) && <OneMonthExpiryMessage />
        )}
        {!isDesktopViewport && <MobileHeader />}
        <Layout>
          {isDesktopViewport && <AppHeader />}

          <Content className="gx-layout-content">
            {/* commented for future use */}
            {/* {!isOnline && <NetworkOffline />} */}
            <div
              className={clsx(isDesktopViewport && 'gx-main-content-wrapper')}
            >
              <Outlet />
            </div>
            <Footer className="app-footer">
              <div className="mobile-layout">
                digiQC © {new Date().getFullYear()} (v{VERSION})
              </div>
              <div className="app-footer-product">
                <span>Product by</span>
                <span className="app-footer-product-title">
                  <a
                    href="https://www.digiqc.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SPACEIFY
                  </a>
                </span>
              </div>
            </Footer>
          </Content>
        </Layout>
      </Layout>
      {state?.showVerifyDetailsModal && (
        <VerifyDetailsModal openPrompt={state?.showVerifyDetailsModal} />
      )}
    </>
  );
};

export default App;
